import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../blocks/CarouselItem";
import MiniLegend from "./../../../items/MiniLegend";
import {TERTIARY_EDUCATION_ARRAY} from "./../../../../helpers/colors";
import {createTertiaryEducationScale} from "./../../../../helpers/formatters";
import {Treemap} from "d3plus-react";
import {numberWithCommas, toPercentage} from "../../../../helpers/formatters";


class JobDelta extends Component {
  constructor(props) {
    super(props);

    let metric, title, subtitle1, subtitle2, paragraph;
    if (props.mode === "growth") {
      title = "Employers may find it difficult to fill new positions in growing categories";
      subtitle1 = "Many jobs that employers might need to fill require a higher level of skills";
      subtitle2 = "Total gross job growth by 2030, declining ISCO2 occupation groups only, thousands.";
      paragraph = <p>Employers, too, may have challenges finding new workers with the skills needed. Many of the fastest-growing occupations, such as software and application developers and nursing professionals, require specialized skills. Today only about 40 percent of Europe’s workforce has a tertiary education, but nearly 60 percent of growing occupations require it. Two exceptions are cleaners and helpers, as well as professional care workers—typically low-wage roles. Filling these jobs may be particularly challenging in megacities and superstar hubs, where potential job growth will be highest but housing is in short supply and infrastructure capacity is limited.</p>;
      metric = "region_aggregated_jobs_gained_isco4";
    }
    else {
      title = "Some 21 million people may need to change occupations";
      subtitle1 = "Some of the largest occupational categories in Europe have the highest potential for displacement";
      subtitle2 = "";
      metric = "region_aggregated_jobs_lost_isco4_negative";
      paragraph = <><p>In our midpoint automation adoption scenario, almost 22 percent of current work activities (equivalent to 53 million jobs) could be automated by 2030. Yet the economy should continue to grow and generate jobs at the same time.</p><p>Many of the jobs that are lost will match up with jobs that are added, which means that many displaced workers may be able to find similar positions. But 21 million people, most of whom lack tertiary education, may need to change occupations by 2030, moving from declining to growing categories.</p></>;
    }
    this.state = {
      data: [],
      metric,
      title,
      subtitle1,
      subtitle2,
      paragraph,
      colorScale: createTertiaryEducationScale()
    };
  }

  render() {
    const {metric, title, subtitle1, colorScale, paragraph} = this.state;
    const {occData, mode} = this.props;
    let data = occData;

    data = occData.map(x => ({...x, color: colorScale(x["share_no_tertiary_education"])}));

    const colors = TERTIARY_EDUCATION_ARRAY.map(c => ({label: c[0], color: c[1]}));

    const chartConfig = {
      data,
      id: "isco_2_name",
      legend: false,
      share: false,
      tooltipConfig: {
        body: d => `<div>Total gross job ${mode} by 2030 (thousands): ${numberWithCommas(d.region_aggregated_jobs_gained_isco4.toFixed(1))}<br/>Share without tertiary education: ${toPercentage(d.share_no_tertiary_education, 1)}%</div>`,
        tbody: []
      },
      height: 400,
      groupBy: ["isco_2_name", "isco_2_name"],
      sum: metric,
      shapeConfig: {
        fill: d => d.color,
        label: d => {
          return [d.isco_2_name, numberWithCommas(Math.round(d[metric]))];
        },
      },
      sort: (a, b) => {
        return b.value - a.value;
      }
    };

    return (
      <CarouselItem title={title} subtitle={subtitle1}>
        <div className="fow-col fow-col-1-3 fow-lg-col-1-2 fow-md-col-1">
          {paragraph}
        </div>
        <div className="fow-col fow-col-2-3 fow-lg-col-1-2 fow-md-col-1">
          <MiniLegend colors={colors} title="Share of workers without tertiary education, %" secondTitle={`Total gross job ${mode} by 2030, declining ISCO2 occupation groups only, thousands.`} />
          <Treemap config={chartConfig} />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    occData: state.db.data.facts.occupational_eu ? state.db.data.facts.occupational_eu : [],
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(JobDelta);
